import { Box } from "@jewlr/storybook/core"
import PropTypes from "prop-types"
import { connect } from "react-redux"
import styled from "styled-components"

import { ActionButton } from "areas/product/jewlr/components"
import { addToCart } from "areas/product/store/actions"

const AddCartBtn = styled(ActionButton).attrs({
  bg: "text",
  color: "white",
})``

const ItemEditForm = ({ wizard, choices, submitItem, validating }) => {
  let inputChoices = {}
  Object.keys(choices)
    .filter((key) => {
      return !choices[key].disabled
    })
    .map((key) => {
      if (Object.keys(choices).includes("sc")) {
        if (key.match(/^s[1-9][1-9]?/)) {
          const stonenum = +key.match(/\d+/)[0]
          if (stonenum <= +choices.sc.value) {
            inputChoices[key] = choices[key].value
          }
        } else {
          inputChoices[key] = choices[key].value
        }
      } else {
        inputChoices[key] = choices[key].value
        if (/img[0-9]+/.test(key) && choices[key].threshold_value) {
          inputChoices[`${key}_th`] = choices[key].threshold_value
        }
      }
    })
  if (!wizard.formUrl) {
    return ""
  }

  return (
    <Box>
      <form
        action={wizard.formUrl}
        id="edit-form"
        method="post"
        onSubmit={(e) => {
          e.preventDefault()
          submitItem(e, validating)
        }}
      >
        <input
          hidden
          name="order_params"
          readOnly
          type="text"
          value={wizard.orderParams}
        />
        {Object.keys(inputChoices).map((key) => {
          return (
            <input
              hidden
              key={key}
              name={key}
              readOnly
              type="text"
              value={
                typeof inputChoices[key] === "object"
                  ? JSON.stringify(inputChoices[key])
                  : inputChoices[key]
              }
            />
          )
        })}
        <Box mb={2}>
          <AddCartBtn
            data-cy="order-actions-cart-edit-item-next-btn"
            type="submit"
          >
            Update Order
          </AddCartBtn>
        </Box>
      </form>
    </Box>
  )
}
const mapStateToProps = (state) => {
  return {
    choices: state.choices,
    validating: state.wizardUI.isAddingToCart,
    wizard: state.wizard,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    submitItem: (e, validating) => {
      if (!validating) {
        e.preventDefault()
        dispatch(addToCart())
      }
    },
  }
}

ItemEditForm.propTypes = {
  choices: PropTypes.object,
  submitItem: PropTypes.func,
  validating: PropTypes.bool,
  wizard: PropTypes.object,
}

export default connect(mapStateToProps, mapDispatchToProps)(ItemEditForm)
